import script from "./gsrst010201.vue?vue&type=script&setup=true&lang=js"
export * from "./gsrst010201.vue?vue&type=script&setup=true&lang=js"

import "./gsrst010201.vue?vue&type=style&index=0&id=6c12b09a&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6c12b09a"]])

export default __exports__